/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import Banner from 'common/components/banner/banner';
// eslint-disable-next-line no-restricted-imports
import PrimaryLinkButton from 'common/components/controls/link/link';
import * as React from 'react';

// eslint-disable-next-line no-restricted-imports
import { N0 } from 'common/lib/colors/index';
// eslint-disable-next-line no-restricted-imports
import { forNamespace } from 'common/lib/util/i18n';

import styles from './large-team-boards-cta-banner.less';

interface LargeBannerProps {
  teamName: string;
  teamBoardsLink: string;
  onDismiss: () => void;
  onClickLink?: React.EventHandler<React.MouseEvent<HTMLElement>>;
}

const LargeBanner = (props: LargeBannerProps) => {
  const format = forNamespace('board section banner');

  return (
    <div className={styles.largeTeamBoardsBannerPadding}>
      <Banner
        onDismiss={props.onDismiss}
        bannerColor={N0}
        shadow
        roundedCorners
        alignCloseTop
      >
        <div className={styles.largeTeamBoardsBanner}>
          <div className={styles.teamBoardsBannerImage}>
            <img
              src={require('images/banners/happy-team.svg')}
              width="150"
              height="150"
              alt=""
              role="presentation"
            />
          </div>
          <div className={styles.teamBoardsBannerHeader}>
            <h4>{format('welcome to the team')}</h4>
            <p className={styles.teamBoardsBannerParagraph}>
              {format('all set up', { teamName: props.teamName })}
            </p>
            <div className={styles.teamBoardsButton}>
              <PrimaryLinkButton
                link={props.teamBoardsLink}
                onClick={props.onClickLink}
              >
                {format('see all boards')}
              </PrimaryLinkButton>
            </div>
          </div>
        </div>
      </Banner>
    </div>
  );
};

export default LargeBanner;



// WEBPACK FOOTER //
// ./app/scripts/views/member/team-boards-cta/large-team-boards-cta-banner.tsx